module.exports = __webpack_public_path__ + "img/ic_96_smiley@2x.99ea1f05.png";